import { render } from "./admin-example-companies.vue?vue&type=template&id=2e11869e"
import script from "./admin-example-companies.vue?vue&type=script&lang=js"
export * from "./admin-example-companies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-example-companies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e11869e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e11869e', __exports__)) {
    api.reload('2e11869e', __exports__)
  }
  
  module.hot.accept("./admin-example-companies.vue?vue&type=template&id=2e11869e", () => {
    api.rerender('2e11869e', render)
  })

}


export default __exports__